import React, { useState, useEffect } from 'react';
import { Form, Alert, Spinner } from 'react-bootstrap';
import ModalGlobal from '../../../../../GlobalModules/Utility/Components/ModalGlobal';
import { closeBusinessRegister } from '../../../BusinessRegister/Controller/BusinessRegisterController';
import Utility from '../../../../../GlobalModules/Utility/Utility';

const CloseRegisterModal = ({ t, show, onHide, mode, registerData }) => {
    const [closingAmount, setClosingAmount] = useState('');
    const [creditCardSlips, setCreditCardSlips] = useState(0);
    const [cheques, setCheques] = useState(0);
    const [formError, setFormError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (show && registerData) {
            setFormError('');
            // console.log("registerData====",registerData)
            // Active Business Register (registerData)
            setClosingAmount(registerData.orderAmount || registerData.opening_amount || '');
            setCreditCardSlips(registerData.credit_card_slips || 0);
            setCheques(registerData.cheques || 0);
        }
    }, [show, registerData]);

    const handleSubmit = async () => {
        if (!closingAmount || parseFloat(closingAmount) < 0) {
            setFormError(t('order.businessRegister.enterValidAmount', 'Enter a valid amount'));
            return;
        }

        setLoading(true);

        const payload = {
            closing_amount: parseFloat(closingAmount),
            credit_card_slips: parseInt(creditCardSlips),
            cheques: parseInt(cheques),
            store_id: localStorage.getItem("store_id")
        };

        const result = await closeBusinessRegister(payload);

        setLoading(false);

        if (result.success) {
            // print the receipt or next pop up   <=====
            onHide(true); // Pass true to indicate successful register closure
            // window.location.reload();
            Utility.toastNotifications(result?.message,'Success','success')
        } else {
            setFormError(result.message || t('order.businessRegister.closeFailed', 'Failed to close register'));
        }
    };

    return (
        <ModalGlobal
            show={show}
            onHide={() => onHide(false)}
            backdrop="static"
            keyboard={false}
            className="business-register-modal"
            headerclassName="close_btn_icon"
            bodyClassName="p-4"
            title={
                <span>
                    {mode === 'close'
                        ? t('order.businessRegister.closeTitle', 'Close Register')
                        : t('order.businessRegister.exitTitle', 'Exit Register')}
                </span>
            }
            closeButton={true}
            headerShow={true}
            footer={true}
            saveShow={true}
            cancelShow={true}
            onSave={handleSubmit}
            onCancel={() => onHide(false)}
            saveButtonLabel={t('continue', 'Continue')}
            cancelButtonLabel={t('common.buttons.cancel', 'Cancel')}
            saveButtonClassName="btn btn-primary"
            cancelButtonClassName="btn btn-white"
            saveButtonDisabled={loading}
            cancelButtonDisabled={loading}
            body={
                <div>
                    {formError && <Alert variant="danger">{formError}</Alert>}

                    {loading ? (
                        <div className="text-center p-4">
                            <Spinner animation="border" role="status" />
                        </div>
                    ) : (
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    {t('order.businessRegister.totalAmount', 'Total Amount')}
                                </Form.Label>
                                <Form.Control
                                    type="number"
                                    value={closingAmount}
                                    onChange={(e) => setClosingAmount(e.target.value)}
                                    min={0}
                                    step="0.01"
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>
                                    {t('order.businessRegister.totalCreditCardSlips', 'Total Credit Card Slips')}
                                </Form.Label>
                                <Form.Control
                                    type="number"
                                    value={creditCardSlips}
                                    onChange={(e) => setCreditCardSlips(e.target.value)}
                                    min={0}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>
                                    {t('order.businessRegister.totalCheques', 'Total Cheques')}
                                </Form.Label>
                                <Form.Control
                                    type="number"
                                    value={cheques}
                                    onChange={(e) => setCheques(e.target.value)}
                                    min={0}
                                />
                            </Form.Group>

                            {mode === "close"
                                ? t('order.businessRegister.closeConfirmation', 'Are you sure you want to close register?')
                                : t('order.businessRegister.exitConfirmation', 'Are you sure you want to exit register?')}
                        </Form>
                    )}
                </div>
            }
        />
    );
};



export default CloseRegisterModal;
